module.exports = __webpack_public_path__ + "img/ms.a1f53551.png";